import React, { Component } from "react";
import { Route, Switch, Link } from "react-router-dom";
import Box from "../Box";
import Chart from "../Chart";
import ListData from "../ListData";
import TableData from "../TableData";
import DatePicker from "../DatePicker";
import MultiSelect from "../MultiSelect";
import {connect} from 'react-redux'
import LoadingModal from "../LoadingModal";
import "./styles.css";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Table,
  Tab,
  Icon
} from "semantic-ui-react";
import moment from "moment";
import { getSelectorAuth } from "../../modules/auth/AuthSelectors";

const options = [
  {
    value: "all",
    text: "Location",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "locone",
    text: "Location One",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "loctwo",
    text: "Location Two",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  }
];

class Overview extends Component {
  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }

  reset() {
    this.setState({ value: undefined });
  }

  setProducts() {
    this.setState({ value: "products" });
  }

  setValue(e, data) {
    this.setState({ value: data.value });
  }

  render() {
    const { value } = this.state;
    const {
      // TODO: esquire-New Data starts here (Uncomment below code)
      sales_by_shift,
      inventory_chart,
      customer_footfall,
      ticket_size_chart,
      ticket_size,
      items_per_ticket,
      customers_served,
      // New Data ends here

      // breakfast,
      // lunch,
      // dinner,
      net_sales,
      avg_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category_chart,
      sales_by_category,
      sales_by_channel,
      sales_by_sub_category,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category,
      gross_sales,
      void_number,
      refunds,
      refunds_number,
      discounts,
      net_taxes,
      total_cogs,
      payment_method_chart,
      refund_chart,
      voids_chart,
      tabs,
      tips,
      service_charges,
      delivery,
      total_collected,
      compile_time
    } = this.props;






    //TODO: esquire- New data sample starts here (comment below code)
    // let sales_by_shift={
    //   "series": [
    //     {
    //       "name": 'Morning',
    //       // "yAxis": 1,
    //       "color": {
    //         "linearGradient": {
    //           "x2": 0,
    //           "y1": 0,
    //           "x1": 0,
    //           "y2": 1
    //         },
    //         "stops": [
    //           [
    //             0,
    //             "#f2a942"
    //           ],
    //           [
    //             1,
    //             "#ffb91a"
    //           ]
    //         ]
    //       },
    //       "type": "column",
    //       "data": [
    //         10000,
    //         15000,
    //         18000,
    //         15000,
    //         21000,
    //         29000,
    //         33000
    //       ],
    //       "showInLegend": true
    //     },
    //     {
    //       "name": "Evening",
    //       // "yAxis": 0,
    //       "color": {
    //         "linearGradient": {
    //           "x2": 0,
    //           "y1": 0,
    //           "x1": 0,
    //           "y2": 1
    //         },
    //         "stops": [
    //           [
    //             0,
    //             "#4363da"
    //           ],
    //           [
    //             1,
    //             "#1eb4d2"
    //           ]
    //         ]
    //       },
    //       "type": "column",
    //       "data": [
    //         12000,
    //         18000,
    //         20500,
    //         20000,
    //         27000,
    //         37000,
    //         40500
    //       ],
    //       "showInLegend": true
    //     },
    //   ],
    //   "categories": [
    //     "Mon",
    //     "Tue",
    //     "Wed",
    //     "Thu",
    //     "Fri",
    //     "Sat",
    //     "Sun"
    //   ]
    // }

    // let inventory_chart={
    //   "series": [
    //     {
    //       "name": "Sales",
    //       "yAxis": 0,
    //       "color": {
    //         "linearGradient": {
    //           "x2": 0,
    //           "y1": 0,
    //           "x1": 0,
    //           "y2": 1
    //         },
    //         "stops": [
    //           [
    //             0,
    //             "#feba1b"
    //           ],
    //           [
    //             1,
    //             "#f8c282"
    //           ]
    //         ]
    //       },
    //       "type": "column",
    //       "data": [
    //         163368,
    //         173893,
    //         153059,
    //         231385,
    //         251645,
    //         330791,
    //         326440
    //       ],
    //       "showInLegend": false
    //     }
    //   ],
    //   "categories": [
    //     "Mon",
    //     "Tue",
    //     "Wed",
    //     "Thu",
    //     "Fri",
    //     "Sat",
    //     "Sun"
    //   ]
    // }
    // let customer_footfall={
    //   "series": [
    //     {
    //       "name": "Sales",
    //       "yAxis": 0,
    //       "color": {
    //         "linearGradient": {
    //           "x2": 0,
    //           "y1": 0,
    //           "x1": 0,
    //           "y2": 1
    //         },
    //         "stops": [
    //           [
    //             0,
    //             "#4fb8f1"
    //           ],
    //           [
    //             1,
    //             "#00cace"
    //           ]
    //         ]
    //       },
    //       "type": "column",
    //       "data": [
    //         163368,
    //         173893,
    //         153059,
    //         231385,
    //         251645,
    //         330791,
    //         326440
    //       ],
    //       "showInLegend": false
    //     }
    //   ],
    //   "categories": [
    //     "Mon",
    //     "Tue",
    //     "Wed",
    //     "Thu",
    //     "Fri",
    //     "Sat",
    //     "Sun"
    //   ]
    // }
    // let ticket_size_chart={
    //   "series": [
    //     {
    //       "name": "Sales",
    //       "yAxis": 0,
    //       "color": {
    //         "linearGradient": {
    //           "x2": 0,
    //           "y1": 0,
    //           "x1": 0,
    //           "y2": 1
    //         },
    //         "stops": [
    //           [
    //             0,
    //             "#d764e7"
    //           ],
    //           [
    //             1,
    //             "#f7bf86"
    //           ]
    //         ]
    //       },
    //       "type": "column",
    //       "data": [
    //         163368,
    //         173893,
    //         153059,
    //         231385,
    //         251645,
    //         330791,
    //         326440
    //       ],
    //       "showInLegend": false
    //     }
    //   ],
    //   "categories": [
    //     "Mon",
    //     "Tue",
    //     "Wed",
    //     "Thu",
    //     "Fri",
    //     "Sat",
    //     "Sun"
    //   ]
    // }
    // let ticket_size={
    //   header:'Ticket Size',
    //   original_value:3500,
    //   value: '3,500',
    //   data:{},
    //   text:''
    // }
    // let items_per_ticket={
    //   header:'Items per Ticket',
    //   original_value:500,
    //   value: '500',
    //   data:{},
    //   text:''
    // }
    // let customers_served={
    //   header:'Customers Served',
    //   original_value:178,
    //   value: '178',
    //   data:{},
    //   text:''
    // }
    // New Data sample ends here

    // console.log("top_items_by_sales : ", top_items_by_sales)
    // console.log("compile_time : ", compile_time)
    // console.log("compile_time ++++: ", new Date(compile_time))

    const gross_margin_value = {
      header: gross_margin.header,
      value: gross_margin.data_one.value
    };

    const totalOnline = {
      header: "Online Stores",
      value: locations.length
    };

    const barChartTemplate = {
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16
        }
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto"
        },
        text: null,
        align: "left",
        x: -5,
        y: 5
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px"
          }
        }
      },
      yAxis: [
        {
          title: {
            text: null
          }
        }
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042"
        }
      },
      labels: {
        items: []
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    const pieChartTemplate = {
      chart: {
        backgroundColor: "none",
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        verticalAlign: "top",
        height: 380,
        color: "#414042"
      },
      title: {
        text: null,
        align: "center",
        verticalAlign: "middle",
        color: "#414042",
        y: 8,
        style: {
          color: "#666874",
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Roboto"
        }
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        style: {
          fontWeight: 200,
          fontSize: 12
        }
      },
      plotOptions: {
        pie: {
          colors: [
            "#ed561b ",
            "#f58233 ",
            "#ffb91a ",
            "#fff263 ",
            "#3050d6 ",
            "#2f7ed8 ",
            "#4897e5 ",
            "#409b23 ",
            "#50b432 ",
            "#97bf2b ",
            "#b8d649 "
          ],
          dataLabels: {
            enabled: false,
            distance: 100,
            color: "#414042",
            style: {
              fontWeight: "400",
              color: "#414042"
            }
          },
          center: ["50%", "55%"]
        }
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    console.log('-----', barChartTemplate);
    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    console.log('-----!', salesByStore);
    // salesByStore['title']['text'] = 'SALES BY STORE';
    console.log("sales_by_store",sales_by_store)
    salesByStore["xAxis"]["categories"] = sales_by_store["categories"];
    salesByStore["series"] = sales_by_store["series"];
    const secondary_yAxis = {
      // gridLineWidth: 1,
      title: {
        text: null
      },
      // opposite: true
    };
    salesByStore["yAxis"].push(secondary_yAxis);

    const refundByDay = JSON.parse(JSON.stringify(barChartTemplate));

    refundByDay["xAxis"]["categories"] = refund_chart["categories"];
    refundByDay["series"] = refund_chart["series"];

    refundByDay["yAxis"].push(secondary_yAxis);

    const voidByDay = JSON.parse(JSON.stringify(barChartTemplate));
    
    voidByDay["xAxis"]["categories"] = voids_chart["categories"];
    voidByDay["series"] = voids_chart["series"];

    voidByDay["yAxis"].push(secondary_yAxis);


const salebyChannel = JSON.parse(JSON.stringify(barChartTemplate));

const sortedKeys = Object.keys(sales_by_channel || {}).sort((a, b) => {
  return a.localeCompare(b); 
});

console.log("zain SALES BY CHANNEL", sales_by_channel)
// console.log("zain SALES BY category", sales_by_category['series'])
// console.log("zain SALES BY category chart", sales_by_category_chart)

const salesByChannelContribution = JSON.parse(JSON.stringify(pieChartTemplate));

const sales_by_channel_sales_contribution = {
  series: [
    {
      type: "pie",
      innerSize: "65%",
      data: sales_by_channel
        ? Object.entries(sales_by_channel).map(([name, values]) => ({
            y: values.sales_contribution,
            name: name || 'Unknown'
          }))
        : [],
      name: "Sales Contribution"
    }
  ],
  title: {
    text: sales_by_channel
      ? (() => {
          const { name, sales_contribution } = Object.entries(sales_by_channel).reduce(
            (max, [name, values]) =>
              values.sales_contribution > max.sales_contribution ? { name, sales_contribution: values.sales_contribution } : max,
            { name: 'No Data', sales_contribution: -Infinity }
          );
          return `${name} (${sales_contribution.toFixed(2)}%)`;
        })()
      : "No Data Available"
  }
};


// const sales_by_channel_sales_contribution = {
//   "series": [
//     {
//       "type": "pie",
//       "innerSize": "65%",
//       "data": [
//         {
//           "y": 6.77,
//           "name": "Delivery - Burger Lab"
//         },
//         {
//           "y": 6.22,
//           "name": "Out Side Dine In"
//         },
//         {
//           "y": 6.75,
//           "name": "Delivery - Blink"
//         },
//         {
//           "y": 6.41,
//           "name": "Take Away"
//         },
//         {
//           "y": 6.46,
//           "name": "Delivery - Food Panda"
//         },
//         {
//           "y": 6.82,
//           "name": "Delivery - Indolj"
//         },
//         {
//           "y": 6.99,
//           "name": "Delivery - Food Panda "
//         },
//         {
//           "y": 6.50,
//           "name": "Dine In"
//         },
//         {
//           "y": 6.60,
//           "name": "Vendor Delivery"
//         },
//         {
//           "y": 6.35,
//           "name": "Delivery -Dine Out "
//         },
//         {
//           "y": 6.59,
//           "name": "Delivery - Call Center"
//         },
//         {
//           "y": 6.68,
//           "name": "Delivery - Website"
//         },
//         {
//           "y": 6.80,
//           "name": "Delivery  Golootlo ( Online Payment)"
//         },
//         {
//           "y": 7.15,
//           "name": "Delivery - BL"
//         },
//         {
//           "y": 6.92,
//           "name": "Delivery - Golootlo"
//         }
//       ],
//       "name": "Sales by Category"
//     }
//   ],
//   "title": {
//     "text": "Delivery - BL (7.15%)"
//   }
// }

console.log("zain transformed", sales_by_channel_sales_contribution)
salesByChannelContribution["title"]["text"] = sales_by_channel_sales_contribution["title"]["text"];
salesByChannelContribution["series"] = sales_by_channel_sales_contribution["series"];


const salebyChannelFormate = [];

sortedKeys.forEach(key => {
  var val = sales_by_channel[key];
  salebyChannelFormate.push(key + " (" + val.margin.toFixed(2) + "%)");
});


salebyChannel["xAxis"]["categories"] = salebyChannelFormate;

salebyChannel["series"] = [
  {
    name: "Total Sales",
    data: sortedKeys.map(key => sales_by_channel[key].total_sales), 
    type: "column", 
    color: "#7cb5ec"
  },
  {
    name: "Total COGS",
    data: sortedKeys.map(key => sales_by_channel[key].total_cogs), 
    type: "column",
    color: "#f7a35c"
  }
];


    const paymentMethod = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    paymentMethod["xAxis"]["categories"] = payment_method_chart["categories"];
    paymentMethod["series"] = payment_method_chart["series"];

    const salesbyDay = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    salesbyDay["xAxis"]["categories"] = sales_by_day["categories"];
    salesbyDay["series"] = sales_by_day["series"];


   

    const salesbyHour = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyHour['title']['text'] = 'SALES BY HOUR';
    salesbyHour["xAxis"]["categories"] = sales_by_hour_chart["categories"];
    salesbyHour["series"] = sales_by_hour_chart["series"];

    let salesByCategory = { ...pieChartTemplate };
    salesByCategory["title"]["text"] = sales_by_category_chart["title"]["text"];
    salesByCategory["series"] = sales_by_category_chart["series"];

    let marginBystore = { data: { values: [] }, header: "Margin by Store" };
    all_locations_insights.map((item, index) => {
      let value = {
        category: { value: item.name },
        amt_cur: { value: item.gross_margin.data_one.value }
      };
      marginBystore["data"]["values"].push(value);
    });

    const basketSize = {
      header: "BASKET SIZE",
      data: {
        values: [
          {
            category: { value: avg_order_size.header },
            amt_cur: { value: avg_order_size.value }
          },
          {
            category: { value: avg_order_value.header },
            amt_cur: { value: avg_order_value.value },
            currency: "Rs."
          },
          {
            category: { value: top_basket_category.header },
            amt_cur: { value: top_basket_category.value }
          }
        ]
      }
    };
    const saleSummary = {
      header: "SALES SUMMARY",
      data: {
        values: [
          {
            category: { value: gross_sales.header },
            amt_cur: { value: gross_sales.value }
          },
          {
            category: { value: refunds.header },
            amt_cur: { value: refunds.value }
          },
          {
            category: { value: discounts.header },
            amt_cur: { value: discounts.value }
          },
          {
            category: { value: net_sales.header },
            amt_cur: { value: net_sales.value }
          },
          {
            category: { value: net_taxes.header },
            amt_cur: { value: net_taxes.value }
          }
        ]
      }
    };
    net_sales.header = "Total Revenue";
    top_items_by_sales.header = "Top Selling Menu Products";
    lowest_items_by_sales.header = "Low Selling Menu Products";

    const formatNum = num => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    let time = compile_time ? new Date(compile_time) : '';
    // let formatted_date = compile_time.getFullYear() + "-" + (compile_time.getMonth() + 1) + "-" + compile_time.getDate() + " " + compile_time.getHours() + ":" + compile_time.getMinutes() + ":" + compile_time.getSeconds() 
    // console.log("tabs", tabs);
    let {auth}=this.props;
    let {filters}=auth;
    var salesByShift ;
    var inventoryChart;
    var customerFootfall;
    var ticketSize;
    if(filters && filters.has_inventory){
      // Static Charts starts here
      salesByShift = JSON.parse(JSON.stringify(barChartTemplate));

      salesByShift["xAxis"]["categories"] = sales_by_shift["categories"];
      salesByShift["series"] = sales_by_shift["series"];
      salesByShift["yAxis"].push(secondary_yAxis);

      inventoryChart = JSON.parse(JSON.stringify(barChartTemplate));
      // salesbyDay['title']['text'] = 'SALES BY DAY';
      inventoryChart["xAxis"]["categories"] = inventory_chart["categories"];
      inventoryChart["series"] = inventory_chart["series"];
      inventoryChart['yAxis']= inventory_chart["yAxis"];
      if (inventory_chart["yAxis"]){
        inventoryChart["yAxis"]=inventory_chart["yAxis"];
      }
      else{
        inventoryChart["yAxis"] = secondary_yAxis;
      }

      customerFootfall = JSON.parse(JSON.stringify(barChartTemplate));
      // salesbyDay['title']['text'] = 'SALES BY DAY';
      customerFootfall["xAxis"]["categories"] = customer_footfall["categories"];
      customerFootfall["series"] = customer_footfall["series"];
      if (customer_footfall["yAxis"]){
        customerFootfall['yAxis'] = customer_footfall["yAxis"]
      }
      else{
        customerFootfall["yAxis"] = secondary_yAxis;
      }

      ticketSize = JSON.parse(JSON.stringify(barChartTemplate));
      // salesbyDay['title']['text'] = 'SALES BY DAY';
      ticketSize["xAxis"]["categories"] = ticket_size_chart["categories"];
      ticketSize["series"] = ticket_size_chart["series"];
      if (ticket_size_chart["yAxis"]){
        ticketSize["yAxis"] = ticket_size_chart["yAxis"];
      }
      else{
        customerFootfall["yAxis"] = secondary_yAxis;
      }
      // ticketSize['yAxis'] = secondary_yAxis
      
      // Static Charts ends here
    }
   
    return (
      <div>
        <Grid.Row style={{ float: "right" }}>
          {time ? <div className='lastUpdatedText'
          >
            Last Updated: {time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate() + " " + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds()} </div> : null}
          <Grid.Column>
            <MultiSelect />
          </Grid.Column>
          <Grid.Column>
            <div style={styles.datePicker}>
              <DatePicker />
            </div>
          </Grid.Column>
        </Grid.Row>
        <div className="innersection">
          <Header style={styles.mainHeadig} as="h3">
            SALES OVERVIEW
          </Header>

          {
            filters && filters.has_inventory ?
            <Grid columns={4}>
              <Box componentData={net_sales} nestedComponentData={{
                text:'Daily Average Sales:',
                value: avg_sales.value
              }} />
              <Box currency="Rs." componentData={gross_margin_value} nestedComponentData={{
                text:'COGS:',
                value:total_cogs.value
              }} />
              <Box componentData={customers_served} />
              <Box componentData={ticket_size} nestedComponentData={{
                text:'Items per Ticket: ',
                value:items_per_ticket.value
              }} />
              {/* <Box componentData={total_orders} /> */}
            </Grid>
          : <Grid columns={5}>
              <Box componentData={net_sales} />
              <Box componentData={avg_sales} />
              <Box componentData={total_cogs} />
              <Box currency="Rs." componentData={gross_margin_value} />
              <Box componentData={total_orders} />
            </Grid> 
          }

          <Grid columns={3}>
            <Chart title="SALES BY DAY" data={salesbyDay} />
            <Chart title="SALES BY HOUR" data={salesbyHour} />
            {filters && filters.has_inventory? 
            <Chart title="SALES BY SHIFT" data={salesByShift} />
            :
            <ListData componentData={basketSize} />}
          </Grid>


          {filters && filters.has_inventory? 
            <Grid columns={3}>
              <Chart title="INVENTORY VALUE" data={inventoryChart} />
              <Chart title="CUSTOMER FOOTFALL" data={customerFootfall} />
              <Chart title="TICKET SIZE" data={ticketSize} />
            </Grid>
          :null}

          {/* {breakfast && lunch && dinner ? ( */}
          {tabs ? (
            <Grid columns={1}>
              <Table
                className="mainTable alignment"
                fixed
                style={styles.mainTable}
              >
                <Table.Header>
                  <Table.Row style={styles.headerRow}>
                    <Table.HeaderCell textAlign="left" style={styles.hederCell}>
                      Sales Summary
                    </Table.HeaderCell>
                    {tabs.map((tab, index) => (
                      <Table.HeaderCell key={index} style={styles.hederCell}>
                        {tab.label}
                      </Table.HeaderCell>
                    ))}

                    {/* <Table.HeaderCell style={styles.hederCell}>
                      Breakfast
                    </Table.HeaderCell>
                    <Table.HeaderCell style={styles.hederCell}>
                      Lunch
                    </Table.HeaderCell>
                    <Table.HeaderCell style={styles.hederCell}>
                      Dinner
                    </Table.HeaderCell> */}
                    <Table.HeaderCell style={styles.hederCell}>
                      TOTAL
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Gross Sales
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].gross_sales
                          ? this.props[tab.key].gross_sales.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {gross_sales ? gross_sales.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Discount & Comps
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].discounts
                          ? this.props[tab.key].discounts.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {discounts ? discounts.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Total Revenue
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].net_sales
                          ? this.props[tab.key].net_sales.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {net_sales.value}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      COGS
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].total_cogs
                          ? this.props[tab.key].total_cogs.value
                          : 0}
                      </Table.Cell>
                    ))}

                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {total_cogs ? total_cogs.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Margin By Rs
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        Rs.{" "}
                        {this.props[tab.key].gross_margin
                          ? this.props[tab.key].gross_margin.data_one.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      Rs. {gross_margin ? gross_margin.data_one.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Margin By %
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].gross_margin
                          ? this.props[tab.key].gross_margin.data_two.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {gross_margin ? gross_margin.data_two.value : 0}%
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Tax Collected
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].net_taxes
                          ? this.props[tab.key].net_taxes.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {net_taxes ? net_taxes.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Tips
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].tips
                          ? this.props[tab.key].tips.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {tips ? tips.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Service charge
                    </Table.Cell>

                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].service_charges
                          ? this.props[tab.key].service_charges.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {service_charges.value}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Delivery charges
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].delivery
                          ? this.props[tab.key].delivery.value
                          : 0}
                      </Table.Cell>
                    ))}

                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {delivery ? delivery.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Total Collected
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].total_collected
                          ? this.props[tab.key].total_collected.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {total_collected ? total_collected.value : 0}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row style={styles.tablerow}>
                    <Table.Cell
                      verticalAlign="middle"
                      textAlign="left"
                      style={styles.tableCellfirst}
                    >
                      Voids # / Rs
                    </Table.Cell>
                    {tabs.map((tab, index) => (
                      <Table.Cell
                        key={index}
                        verticalAlign="middle"
                        style={styles.tableCell}
                      >
                        {this.props[tab.key].void_number
                          ? this.props[tab.key].void_number.value
                          : 0}{" "}
                        |{" "}
                        {this.props[tab.key].void
                          ? this.props[tab.key].void.value
                          : 0}
                      </Table.Cell>
                    ))}
                    <Table.Cell
                      verticalAlign="middle"
                      className="totalSales"
                      style={styles.tableCell}
                    >
                      {void_number ? void_number.value : 0}|{" "}
                      {this.props.void ? this.props.void.value : 0}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid>
          ) : null}
          <Grid columns={3} />
          <Grid columns={3}>
            <Chart title="PAYMENT METHOD" data={paymentMethod} />
            <Chart title="SALES BY CATEGORY" data={salesByCategory} />
            <Chart title="VOIDS" data={voidByDay} />
          </Grid>
          <div className="pieChartWrapper">
            <Grid columns={2}>    
              <Chart title="SALES BY CHANNEL" data={salebyChannel} />
              <Chart title="SALES BY Contribution" data={salesByChannelContribution} />
            </Grid>
          </div>
          <Grid columns={2}>
            <TableData
              style={{ marginLeft: -25 }}
              currency="Rs."
              componentData={top_items_by_sales}
            />
            <TableData currency="Rs." componentData={lowest_items_by_sales} />
          </Grid>
          <Grid columns={2}>
            <TableData currency="Rs." componentData={sales_by_category} />
            <TableData currency="Rs." componentData={sales_by_sub_category} />
          </Grid>
          <Grid columns={2}>
            <Header as="h5" style={styles.heading}>
              Locations
            </Header>

            <Table fixed style={styles.mainTable}>
              <Table.Header>
                <Table.Row style={styles.headerRow}>
                  <Table.HeaderCell textAlign="left" style={styles.hederCell}>
                    AREA
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                    ORDERS
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                    SALES
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                    AVG SALES
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                   TAX COLLECTED
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                   GROSS SALES
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                   COGS MARGIN BY %
                  </Table.HeaderCell>
                  <Table.HeaderCell style={styles.hederCell}>
                   COGS
                  </Table.HeaderCell>

  
                  {/* <Table.HeaderCell style={styles.hederCell}>
                  Avg Tax Collected
                  </Table.HeaderCell> */}
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {sales_by_store
                  ? sales_by_store["categories"].map((store, index) => {
                    return (
                      <Table.Row style={styles.tablerow} key={index}>
                        <Table.Cell
                          verticalAlign="middle"
                          textAlign="left"
                          style={styles.tableCellfirst}
                        >
                          {store}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][1]["data"][index]
                          )}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][0]["data"][index]
                          )}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][2]["data"][index]
                          )}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][3]["data"][index]
                          )}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][6]["data"][index]
                          )}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][4]["data"][index]
                          )} %
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(
                            sales_by_store["series"][5]["data"][index]
                          )}
                        </Table.Cell>


                      </Table.Row>
                    );
                  })
                  : null}
              </Table.Body>
            </Table>
          </Grid>
        </div>
      </div>
    );
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    marginTop: 20,
    marginBottom: 15,
    paddingBottom: 18,
    paddingLeft: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#c1c1c5"
  },
  comingSoon: {
    backgroundColor: "#59d345",
    color: "#fff",
    fontFamily: "Roboto",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white"
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874"
  },
  title: {
    padding: 10,
    fontSize: 22
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435"
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400
  },

  mainTable: {
    borderWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "transparent"
  },
  tablerow: {
    textAlign: "center",
    fontFamily: "Roboto",
    backgroundColor: "none"
  },
  hederCell: {
    backgroundColor: "#ECF3FA",
    color: "#999",
    fontSize: 14,
    fontWeight: 300,
    paddingTop: 15,
    paddingBottom: 15,
    borderColor: "#c1c1c5",
    borderWidth: 0.7,
    borderRadius: 0
  },
  tableCellfirst: {
    backgroundColor: "#F9F9FE",
    color: "#999",
    fontSize: 14,
    paddingTop: 15,
    paddingBottom: 15,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  tableCell: {
    backgroundColor: "#F9F9FE",
    color: "#313131",
    fontSize: 14,
    paddingTop: 25,
    paddingBottom: 25,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  headerRow: {
    textAlign: "center",
    fontFamily: "Roboto"
  },
  heading: {
    fontSize: 16,
    color: "rgb(102, 104, 116)",
    paddingBottom: 10,
    paddingLeft: 15,
    paddingTop: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto"
  }
};

export default connect(state=>{
  return {
    auth:getSelectorAuth(state),
    ...state.analytics
  }
})(Overview);



// WEBPACK FOOTER //
// ./src/components/Tabs/tabData.js